/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = CashOrCard
 *
 * 2 = ServicePlan
 *
 * 3 = LeaseOrFleetAccount
 *
 * 4 = MotabilityAccount
 *
 * 5 = EmacAccount
 *
 * 6 = Warranty
 */
export enum WipAppointmentPreparationPaymentMethod {
  CashOrCard = 1,
  ServicePlan = 2,
  LeaseOrFleetAccount = 3,
  MotabilityAccount = 4,
  EmacAccount = 5,
  Warranty = 6,
}
